import React, { useState, useEffect, useRef } from 'react';
import TaskControls from './ImageRating/TaskControls';
import useTaskData from './ImageRating/useTaskData';
import { useSetTaskAndIteration } from '../hooks/useSetTaskAndIteration';
import {textTaskStatementTarget, textTaskStatementFree} from '../locales/en';
import { useFooter } from './FooterContext';

import IterateController from './ImageRating/IterateController';

import {
    createTask,
    saveTaskDuration,
} from './ImageRating/api';


export default function ImageFreeComponent({ uuid, timer, debugging }) {
    const setTaskAndIteration = useSetTaskAndIteration();
    const { showMessage } = useFooter();

    const {
        taskId,
        setTaskId,
        setCurrentImages,
        currentImages
    } = useTaskData();
    
    const [showInitialImage, setShowInitialImage] = useState(true);

    /** 
     * Handles changes to the "satisfied" state for the task.
     *
     * This function is called when the user clicks the
     * "I'm satisfied" button or cancels the satisfaction dialog.
     * @async
     * @param {boolean} satisfied - Whether the user is satisfied with the current design.
     *   - `true` → user has confirmed satisfaction and the dialog should close.
     *   - `false` → user canceled or wants to continue iterating.
     * @returns {Promise<void>} Resolves when the satisfaction change is fully processed.
     */
    const handleSatisfyChange = async (satisfied) => {
        if (!satisfied) {
            return;
        }

        // try {
        const data = await createTask(uuid);
        const newTaskId = data.taskId;

        setTaskId(newTaskId);
        localStorage.setItem('currentTaskId', newTaskId.toString());
        // setTaskDataInitialized(true);

        setTaskAndIteration(newTaskId, 0);

        showMessage("New task Created", `Task ${newTaskId} was successfully created. The iteration starts again at 0.`, "info");

        // Removed page reload - this was causing image jumping
        // } catch (error) {
        // showMessage("Error", "There was an error creating a new task. Please try again.", "error");
        // }
    };

    // Reset tasks
    const resetTaskId = async () => {
        if (window.confirm("Do you really want to delete all task data? This process cannot be undone.")) {

            // Immediately hide/clear current content to prevent flashing old images
            setCurrentImages([]);
            resetIndex();   
            setTaskId(0);

            // Reset all other states
            setRatedImages({});

            // await deleteAllTasks();

            const taskData = await createTask(uuid);

            // Set new task ID first, before loading data
            setTaskId(taskData.taskId);
            localStorage.setItem('currentTaskId', taskData.taskId.toString());
            setTaskAndIteration(taskData.taskId, 0);

            showMessage("Confirmation", `New task with ID ${taskData.taskId} has been created.`, "info");

            if (timer && typeof timer.start === 'function') {
                timer.start();
                console.log(`Timer started for new Task ${taskData.taskId}`);
            }
            // } catch (error) {
            //     showMessage("Error", `Error during reset: ${error.message}`, "error");
            // }
        }
    };

    return (
        <div className='main'>

            { debugging && 
                <TaskControls
                    uuid={uuid}
                    taskId={taskId}
                    onResetTasks={resetTaskId}
                    onToggleInitialImage={() => setShowInitialImage(prev => !prev)}
                    showInitialImage={showInitialImage}
                    debugging={debugging}
                />
             }
            <div className='rowFlex'>

                <IterateController uuid={uuid}
                    taskId={taskId}
                    timer={timer}
                    saveTaskDuration={saveTaskDuration}
                    onSatisfyChange={handleSatisfyChange}
                    textTaskStatement={taskId === "13" || taskId === 13 ? textTaskStatementFree : textTaskStatementTarget}/>
            </div>
        </div>
    );
}